import { GridFilterActionState, initialState } from 'store/grid'
import { isNotEmpty } from 'utils/is-empty'

import { calculatePageIndex } from './calculatePageIndex'
import { mergeActionState } from './mergeState'

interface ExtraOptions {
  isGoBack?: boolean
}

export const createGridState = (
  initialActionState: GridFilterActionState,
  state: GridFilterActionState,
  extraOptions?: ExtraOptions
): GridFilterActionState => {
  const actionState = extraOptions?.isGoBack && isNotEmpty(state) ? state : initialActionState
  const result = mergeActionState(actionState, initialState())

  return {
    ...result,
    pageIndex: actionState?.pageIndex ?? calculatePageIndex(result.skip, result.take),
    pageSize: actionState?.pageSize ?? result.take,
  }
}
